var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},_vm._l((_vm.banners),function(banner,index){return _c('div',{key:index,staticClass:"banner-item"},[_c('img',{staticClass:"banner-img",attrs:{"src":banner.img_link_url_mobile,"alt":`${banner.name}`},on:{"click":function($event){return _vm.directive(banner.link_url)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }